import {
  submitFedexMfaBackupInputSchema,
  submitFedexMfaBackupOutputSchema,
} from "@redotech/redo-model/fulfillments/fedex-customer-registration";

export const submitFedexMfaBackup = {
  name: "submitFedexMfaBackup" as const,
  input: submitFedexMfaBackupInputSchema,
  output: submitFedexMfaBackupOutputSchema,
};
